const mainRoutes = {
	admin: '/admin',
	client: '/client',
	root: '/'
};

export default mainRoutes;
